<script lang="ts">
    import { onMount } from "svelte";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import { type IGamesController } from "../../controller/IGamesController";
    import { Game } from "../../model/Game";
    import LoadingSpinner from "../components/LoadingSpinner.svelte";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import GameInfoCard from "../fragments/GameInfoCard.svelte";

    let gamesController: IGamesController =
        ConfigurationManager.getInstance().gamesController;

    let games: Game[] = $state([]);
    let loaded = $state(false);

    onMount(() => {
        gamesController.getAllGames().then((incomingGames: Game[]) => {
            games = incomingGames;
        }).finally(() => {
            loaded = true;
        })

    });
</script>

<h1 class="h2">Games</h1>

<div class="row d-flex px-2">
    <LoadingSpinner {loaded} class="m-4 text-center">
        {#each games as game, i}
            <GameInfoCard game={game} class="col-12 col-lg-3 d-flex my-2 px-2"></GameInfoCard>
        {/each}
    </LoadingSpinner>
</div>
